  export const getGridSize = (length) => {
    if (length % 3 === 0) return 4;
    if (length % 2 === 0) return 6;
    return 4;
  };
  

  